import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { InputSwitch } from 'primereact/inputswitch';
import { Checkbox } from 'primereact/checkbox';
import ClassIcon from '../../../../../assets/icons/menu-icons/classes.svg';
import dateUtils from '../../../../../utils/date-format';
import { EditTextDialog } from '../../../../settings/componenets/edit-entity-name-dialog/edit-text-dialog';
import {
  CreateCalendarScheduleDialog,
  ScheduleType,
} from '../../../../calendar/create-calendar-schedule-dialog';
import { LectureDetails } from '../../../../../api/types/lecturers/details/lecture-details';
import { SelectedSlotsState } from '../../../../calendar/tabs/serial/components/time-slots/types/selected-slots';
import { LecturerIdWithActivityTypeId } from '../../../../calendar/tabs/serial/create-lecture-serial-tab';
import { updateLectureNameOperation } from '../operations/update-lecture-name-operation';
import globalProgramStore from '../../../../../stores/program-store';
import globalCourseStore from '../../../../../stores/global-course-store';
import { SessionHeaderItem } from '../../../assignments-and-exams/exams/components/exam-page/session-header/componenets/session-header-item';
import appApi from '../../../../../api/app-api';
import { toast } from 'react-toastify';
import { LectureStatus } from '../../../../../api/types/programs/course/lectures/lecture-status.type';

interface LecturePageDialogHeaderProps {
  lectureData: LectureDetails | undefined;
  lecture: any;
  programId: number | undefined;
  onApproveAddNewSchedule: (
    selectedSlotsState: SelectedSlotsState,
    lecturesIdsWithActivityTypeId: LecturerIdWithActivityTypeId[],
    setIsLoadingCreateLectures: (loading: boolean) => any,
    onHide?: () => any,
    attendanceRequired?: boolean,
    lectureAttendanceSessionNumber?: number,
    lectureBreakMinutes?: number,
    professorRetroactiveWorkingHours?: boolean,
  ) => Promise<void>;
  setLectureData: React.Dispatch<
    React.SetStateAction<LectureDetails | undefined>
  >;
}

export const LecturePageDialogHeader: React.FC<
  LecturePageDialogHeaderProps
> = ({
  lectureData,
  lecture,
  programId,
  onApproveAddNewSchedule,
  setLectureData,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [editLecture, setEditLecture] = useState(false);
  const [attendanceRequire, setAttendanceRequire] = useState(
    lectureData?.lectureInformation.lecture.attendanceRequired ?? false,
  );
  const [isRemote, setIsRemote] = useState(
    lectureData?.lectureInformation.lecture.isRemote ?? false,
  );

  useEffect(() => {
    setAttendanceRequire(
      lectureData?.lectureInformation.lecture.attendanceRequired ?? false,
    );
    setIsRemote(lectureData?.lectureInformation.lecture.isRemote ?? false);
  }, [lectureData]);

  const handleUpdateLectureName = (lectureName: string) => {
    if (!programId || !lectureData) return;

    updateLectureNameOperation(
      programId,
      globalCourseStore.currentId,
      lectureData.lectureInformation.lecture.id,
      lectureName,
      setIsLoading,
      setLectureData,
    );
  };

  const handleUpdateRemoteStatus = async (newIsRemote: boolean) => {
    if (!programId || !lectureData) return;

    setIsRemote(newIsRemote);
    updateLectureNameOperation(
      programId,
      globalCourseStore.currentId,
      lectureData.lectureInformation.lecture.id,
      lectureData.lectureInformation.lecture.lectureName,
      setIsLoading,
      setLectureData,
    );
  };

  return (
    <>
      <div
        style={{
          padding: '0px',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Button
          icon="pi pi-pencil"
          style={{ gap: '4px', height: '35px', width: '35px' }}
          aria-label="Edit"
          tooltip={
            lectureData?.lectureInformation.lecture.lectureStatus ===
            LectureStatus.START
              ? 'לא ניתן לערוך זמני הרצאה שהחלה וטרם התחילה'
              : 'עריכה'
          }
          tooltipOptions={{ showOnDisabled: true }}
          disabled={
            lectureData?.lectureInformation.lecture.lectureStatus ===
            LectureStatus.START
          }
          severity={'warning'}
          onClick={() => setEditLecture(true)}
        />

        <SessionHeaderItem
          headline={'שם המפגש'}
          content={lectureData?.lectureInformation.lecture.lectureName ?? ''}
          image={
            <i
              onClick={() => setIsVisible(true)}
              style={{
                fontSize: '24px',
                cursor: 'pointer',
                color: '#3B82F6',
              }}
              className="pi pi-pencil"
            ></i>
          }
        />
        <EditTextDialog
          id={isVisible ? 1 : undefined}
          value={' '}
          title={'שם המפגש'}
          label={'נא להזין את שם המפגש'}
          loading={isLoading}
          onSave={(id: number, newValue: string) => {
            handleUpdateLectureName(newValue);
          }}
          onHide={() => {
            setIsVisible(false);
          }}
        />
        <SessionHeaderItem
          headline={'תאריך'}
          content={dateUtils.displayDateInText(
            new Date(lecture.schedule.startTime),
          )}
          image={
            <i style={{ fontSize: '24px' }} className="pi pi-calendar"></i>
          }
        />
        <SessionHeaderItem
          headline={'שעות'}
          content={dateUtils.formatTimeRangeBetweenDates(
            lecture.schedule.startTime,
            lecture.schedule.endTime,
          )}
          image={<i style={{ fontSize: '24px' }} className="pi pi-clock"></i>}
        />

        <SessionHeaderItem
          headline={'כיתה'}
          content={lecture.class.className}
          image={ClassIcon}
        />

        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        {/*<Button
              icon="pi pi-external-link"
              style={{ height: '30px', gap: '4px' }}
              label={'עריכת זמני המפגש'}
            />*/}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <label>פרונטלי</label>
          <div style={{ height: '33px', width: '28px' }}>
            <Checkbox
              checked={!isRemote}
              disabled={isLoading}
              /*style={{  }}*/
              onChange={(e) => handleUpdateRemoteStatus(!e.checked)}
            />
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <label>נוכחות חובה</label>
          <div>
            <InputSwitch
              checked={attendanceRequire}
              onChange={(e) => setAttendanceRequire(e.value)}
            />
          </div>
        </div>
      </div>

      {editLecture && (
        <CreateCalendarScheduleDialog
          branchId={
            globalProgramStore.programs.get(globalProgramStore.getCurrentId())
              .metadata.branchId
          }
          courseName={`${globalCourseStore.getCurrentCourse()?.metadata.abstractData.courseName ?? ''} ${globalCourseStore.getCurrentCourse()?.metadata.additionalCourseName ?? ''}`}
          headerTitle="עריכת מפגש"
          allowRetroactiveWorkingHoursSupport={
            lectureData?.lectureInformation.lecture.lectureStatus !==
            LectureStatus.INIT
          }
          allowEditAttedancePartialNumber={
            lectureData?.lectureInformation.lecture.lectureStatus !==
            LectureStatus.INIT
          }
          allowEditBreakMinutes={
            lectureData?.lectureInformation.lecture.lectureStatus !==
            LectureStatus.INIT
          }
          studentAttendacePartialNumber={
            lectureData?.lectureInformation.lecture.attendanceSessionNumber
          }
          editMode={true}
          onApprove={onApproveAddNewSchedule}
          supportMultiple={false}
          timeSlot={
            true
              ? {
                  start: new Date(lecture.schedule.startTime),
                  end: new Date(lecture.schedule.endTime),
                  classId: lecture.class.id,
                }
              : null
          }
          onHide={() => setEditLecture(false)}
          scheduleType={ScheduleType.LECTURE}
          editTimeSlot={{
            start: new Date(lecture.schedule.startTime),
            end: new Date(lecture.schedule.endTime),
            classId: lecture.class.id,
          }}
        />
      )}
    </>
  );
};
